const pushCustomTrackingEvent = function(data = {}) {
    const eventData = { action: '', category: '', label: '', ...data };
    if (window.dataLayer) {
        window.dataLayer.push({
            event: 'customEvent',
            eventData: eventData,
        });
    }
};

export default pushCustomTrackingEvent;
